import { Card } from 'react-native-paper'

// Helper ruby command to convert all of the PNG images to JPEG
// puts Dir['assets/meals/**.png'].map { |f| "convert #{f} -quality 25% #{f.split('.').first}.jpg" }

// Ruby to regenerate this list
// puts Dir['assets/meals/**.jpg'].map { |path| "\"#{path.split('/').last.split('.').first}\": require(\"../#{path}\")," }

const IMAGES = {
  'baked-sausages-and-new-potatoes': require('../assets/meals/baked-sausages-and-new-potatoes.jpg'),
  'baked-sweet-potato-with-feta-cheese-and-chives': require('../assets/meals/baked-sweet-potato-with-feta-cheese-and-chives.jpg'),
  'bbq-chicken-with-grilled-vegetables': require('../assets/meals/bbq-chicken-with-grilled-vegetables.jpg'),
  'bean-soup-with-crispy-bacon': require('../assets/meals/bean-soup-with-crispy-bacon.jpg'),
  'beer-battered-fish-and-chips': require('../assets/meals/beer-battered-fish-and-chips.jpg'),
  'butter-chicken': require('../assets/meals/butter-chicken.jpg'),
  'cheesy-bean-and-beef-nachos': require('../assets/meals/cheesy-bean-and-beef-nachos.jpg'),
  'cheesy-broccoli-pasta-bake': require('../assets/meals/cheesy-broccoli-pasta-bake.jpg'),
  'cheesy-pasta-oven-bake': require('../assets/meals/cheesy-pasta-oven-bake.jpg'),
  'cheesy-tomato-rice': require('../assets/meals/cheesy-tomato-rice.jpg'),
  'classic-blt-sandwiches': require('../assets/meals/classic-blt-sandwiches.jpg'),
  'classic-cheeseburger-with-fries': require('../assets/meals/classic-cheeseburger-with-fries.jpg'),
  'classic-kiwi-lamb-roast': require('../assets/meals/classic-kiwi-lamb-roast.jpg'),
  'classic-kiwi-roast-lamb': require('../assets/meals/classic-kiwi-roast-lamb.jpg'),
  'classic-nachos': require('../assets/meals/classic-nachos.jpg'),
  'creamy-mushroom-risotto': require('../assets/meals/creamy-mushroom-risotto.jpg'),
  'creamy-white-sauce-pasta': require('../assets/meals/creamy-white-sauce-pasta.jpg'),
  'cucumber-and-salmon-panzanella': require('../assets/meals/cucumber-and-salmon-panzanella.jpg'),
  'easy-chicken-stir-fry': require('../assets/meals/easy-chicken-stir-fry.jpg'),
  'garlic-butter-shrimp-pasta': require('../assets/meals/garlic-butter-shrimp-pasta.jpg'),
  'italian-baked-eggplant': require('../assets/meals/italian-baked-eggplant.jpg'),
  'kiwi-classic-fish-and-chips': require('../assets/meals/kiwi-classic-fish-and-chips.jpg'),
  'lamb-ragout': require('../assets/meals/lamb-ragout.jpg'),
  'lemon-garlic-shrimp-pasta': require('../assets/meals/lemon-garlic-shrimp-pasta.jpg'),
  'lemon-herb-chicken-and-rice': require('../assets/meals/lemon-herb-chicken-and-rice.jpg'),
  'mediterranean-rice-salad': require('../assets/meals/mediterranean-rice-salad.jpg'),
  'minestrone-soup': require('../assets/meals/minestrone-soup.jpg'),
  'mushroom-risotto': require('../assets/meals/mushroom-risotto.jpg'),
  'one-pot-mexican-rice': require('../assets/meals/one-pot-mexican-rice.jpg'),
  'one-pot-tomato-orzo': require('../assets/meals/one-pot-tomato-orzo.jpg'),
  'paprika-pork-and-mushroom-casserole': require('../assets/meals/paprika-pork-and-mushroom-casserole.jpg'),
  'pasta-with-tomato-sauce': require('../assets/meals/pasta-with-tomato-sauce.jpg'),
  'pesto-shrimp-linguine': require('../assets/meals/pesto-shrimp-linguine.jpg'),
  'pizza-with-mushrooms-and-mozzarella': require('../assets/meals/pizza-with-mushrooms-and-mozzarella.jpg'),
  'potato-salad-with-bacon-bits': require('../assets/meals/potato-salad-with-bacon-bits.jpg'),
  'prawn-noodle-stir-fry': require('../assets/meals/prawn-noodle-stir-fry.jpg'),
  'prawns-with-garlic-and-rosemary': require('../assets/meals/prawns-with-garlic-and-rosemary.jpg'),
  'roasted-pumpkin-soup': require('../assets/meals/roasted-pumpkin-soup.jpg'),
  'rosemary-pepper-steak': require('../assets/meals/rosemary-pepper-steak.jpg'),
  'simple-bangers-and-mash': require('../assets/meals/simple-bangers-and-mash.jpg'),
  'simple-beef-casserole': require('../assets/meals/simple-beef-casserole.jpg'),
  'simple-beef-lasagne': require('../assets/meals/simple-beef-lasagne.jpg'),
  'simple-beef-pho': require('../assets/meals/simple-beef-pho.jpg'),
  'simple-beef-ramen': require('../assets/meals/simple-beef-ramen.jpg'),
  'simple-butter-chicken': require('../assets/meals/simple-butter-chicken.jpg'),
  'simple-caesar-salad': require('../assets/meals/simple-caesar-salad.jpg'),
  'simple-cheesy-potato-bake': require('../assets/meals/simple-cheesy-potato-bake.jpg'),
  'simple-chicken-and-chorizo-ragu': require('../assets/meals/simple-chicken-and-chorizo-ragu.jpg'),
  'simple-chicken-burritos': require('../assets/meals/simple-chicken-burritos.jpg'),
  'simple-chicken-fajitas': require('../assets/meals/simple-chicken-fajitas.jpg'),
  'simple-chicken-katsu': require('../assets/meals/simple-chicken-katsu.jpg'),
  'simple-chicken-lasagne': require('../assets/meals/simple-chicken-lasagne.jpg'),
  'simple-chicken-noodle-soup': require('../assets/meals/simple-chicken-noodle-soup.jpg'),
  'simple-chicken-pasta-bake': require('../assets/meals/simple-chicken-pasta-bake.jpg'),
  'simple-chicken-pho': require('../assets/meals/simple-chicken-pho.jpg'),
  'simple-chicken-ramen': require('../assets/meals/simple-chicken-ramen.jpg'),
  'simple-chicken-salad': require('../assets/meals/simple-chicken-salad.jpg'),
  'simple-chicken-stir-fry': require('../assets/meals/simple-chicken-stir-fry.jpg'),
  'simple-chilli-con-carne': require('../assets/meals/simple-chilli-con-carne.jpg'),
  'simple-cottage-pie': require('../assets/meals/simple-cottage-pie.jpg'),
  'simple-couscous': require('../assets/meals/simple-couscous.jpg'),
  'simple-curried-sausages': require('../assets/meals/simple-curried-sausages.jpg'),
  'simple-fettuccine-al-burro': require('../assets/meals/simple-fettuccine-al-burro.jpg'),
  'simple-fettuccine-alfredo': require('../assets/meals/simple-fettuccine-alfredo.jpg'),
  'simple-leek-and-potato-soup': require('../assets/meals/simple-leek-and-potato-soup.jpg'),
  'simple-loaded-wedges': require('../assets/meals/simple-loaded-wedges.jpg'),
  'simple-mac-and-cheese-with-bacon': require('../assets/meals/simple-mac-and-cheese-with-bacon.jpg'),
  'simple-mac-and-cheese': require('../assets/meals/simple-mac-and-cheese.jpg'),
  'simple-meat-stew': require('../assets/meals/simple-meat-stew.jpg'),
  'simple-meatball-and-tomato-soup': require('../assets/meals/simple-meatball-and-tomato-soup.jpg'),
  'simple-mushroom-and-leek-pasta': require('../assets/meals/simple-mushroom-and-leek-pasta.jpg'),
  'simple-paella': require('../assets/meals/simple-paella.jpg'),
  'simple-pasta-salad': require('../assets/meals/simple-pasta-salad.jpg'),
  'simple-pesto-pasta': require('../assets/meals/simple-pesto-pasta.jpg'),
  'simple-pumpkin-soup': require('../assets/meals/simple-pumpkin-soup.jpg'),
  'simple-quesadillas': require('../assets/meals/simple-quesadillas.jpg'),
  'simple-rice-risotto': require('../assets/meals/simple-rice-risotto.jpg'),
  'simple-roast-salmon-with-fresh-salad': require('../assets/meals/simple-roast-salmon-with-fresh-salad.jpg'),
  'simple-roast-vegetable-salad': require('../assets/meals/simple-roast-vegetable-salad.jpg'),
  'simple-salmon-and-potato-salad': require('../assets/meals/simple-salmon-and-potato-salad.jpg'),
  "simple-shepherd's-pie": require("../assets/meals/simple-shepherd's-pie.jpg"),
  'simple-shrimp-and-capsicum-paella': require('../assets/meals/simple-shrimp-and-capsicum-paella.jpg'),
  'simple-smash-burgers': require('../assets/meals/simple-smash-burgers.jpg'),
  'simple-spaghetti-aglio-e-olio': require('../assets/meals/simple-spaghetti-aglio-e-olio.jpg'),
  'simple-spaghetti-and-meatballs': require('../assets/meals/simple-spaghetti-and-meatballs.jpg'),
  'simple-spaghetti-puttanesca': require('../assets/meals/simple-spaghetti-puttanesca.jpg'),
  'simple-spicy-tofu-salad': require('../assets/meals/simple-spicy-tofu-salad.jpg'),
  'simple-squash-salad': require('../assets/meals/simple-squash-salad.jpg'),
  'simple-steak-and-chips': require('../assets/meals/simple-steak-and-chips.jpg'),
  'simple-steak-and-vegetables': require('../assets/meals/simple-steak-and-vegetables.jpg'),
  'simple-teriyaki-chicken-udon': require('../assets/meals/simple-teriyaki-chicken-udon.jpg'),
  'simple-tofu-pho': require('../assets/meals/simple-tofu-pho.jpg'),
  'simple-tofu-poke-bowl': require('../assets/meals/simple-tofu-poke-bowl.jpg'),
  'simple-tofu-salad': require('../assets/meals/simple-tofu-salad.jpg'),
  'simple-tofu-stir-fry': require('../assets/meals/simple-tofu-stir-fry.jpg'),
  'simple-tomato-soup': require('../assets/meals/simple-tomato-soup.jpg'),
  'simple-vegan-stir-fry': require('../assets/meals/simple-vegan-stir-fry.jpg'),
  'simple-vege-yaki-udon': require('../assets/meals/simple-vege-yaki-udon.jpg'),
  'simple-vegetable-pasta-bake': require('../assets/meals/simple-vegetable-pasta-bake.jpg'),
  'simple-vegetarian-lasagne': require('../assets/meals/simple-vegetarian-lasagne.jpg'),
  'simple-vegetarian-pho': require('../assets/meals/simple-vegetarian-pho.jpg'),
  'simple-vegetarian-ramen': require('../assets/meals/simple-vegetarian-ramen.jpg'),
  'smoked-salmon-fettuccine': require('../assets/meals/smoked-salmon-fettuccine.jpg'),
  'spaghetti-bolognaise': require('../assets/meals/spaghetti-bolognaise.jpg'),
  'spaghetti-with-pesto': require('../assets/meals/spaghetti-with-pesto.jpg'),
  'stir-fried-chicken-and-broccoli': require('../assets/meals/stir-fried-chicken-and-broccoli.jpg'),
  'teriyaki-chicken-poke-bowl': require('../assets/meals/teriyaki-chicken-poke-bowl.jpg'),
  'teriyaki-chicken-stir-fry-with-rice': require('../assets/meals/teriyaki-chicken-stir-fry-with-rice.jpg'),
  'tex-mex-chicken-salad': require('../assets/meals/tex-mex-chicken-salad.jpg'),
  'tomato-and-basil-pasta': require('../assets/meals/tomato-and-basil-pasta.jpg'),
  'traditional-lasagna': require('../assets/meals/traditional-lasagna.jpg'),
  'tuna-and-tomato-pasta-bake': require('../assets/meals/tuna-and-tomato-pasta-bake.jpg'),
}

const getImageSource = (name) => IMAGES[name.toLowerCase().replaceAll(' ', '-')]

const MealImage = ({ name, ...props }) => (
  <Card.Cover
    resizeMode="cover"
    style={{ margin: -5 }}
    blurRadius={2}
    source={getImageSource(name)}
    fadeDuration={200}
    {...props}
  />
)

export default MealImage
